module.exports = __webpack_public_path__ + "img/121.a0b2cbbf.jpg";